import axios from 'axios';
import type { ExternalUser } from '@/models/externalUser';

class ExternalUserWebservice {
    public getAll(project_id: number) {
        return axios.get<ExternalUser[]>('/externalUsers', {
            params: {
                project_id,
            },
        });
    }

    public store(user: ExternalUser) {
        return axios.post('/externalUsers/store', {
            id: user.id,
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.email,
            tenant: user.tenant,
            company_id: user.company_id,
            project_id: user.project_id,
        });
    }

    public delete(external_users: ExternalUser[], project_id: number) {
        return axios.post('/externalUsers/delete', {
            external_users_ids: external_users.map((user) => user.id),
            project_id,
        });
    }
}

export const externalUserWebservice = new ExternalUserWebservice();
